// extracted by mini-css-extract-plugin
export default {"container":"orders_container__29KC5","orderfeed":"orders_orderfeed__heCAB"};